import Swal from 'sweetalert2';
import $http_ari from '../../../axios-instance-ari';
import {setShowToModal} from './mutations';

/**
 * Obtener estándares
 */
export async function getStandards({commit, state}) {
    if (!state.standards.length) {
        commit('dashboard/load', true, {root: true});
        await $http_ari.get('estandares-fichas-control', {params: state.filtros})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setStandards', response.data.estandares);
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener recomendaciones.
 *
 * @param reset_page Determina si se debe reiniciar la paginación.
 */
export async function getRecommendations({commit, state}, reset_page = true) {

    if (reset_page) {
        state.params.page = 1;
    }

    commit('dashboard/load', true, {root: true});
    await $http_ari.get('recomendaciones', {params: state.params})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRecommendations', response.data.data);
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener recomendación por id.
 *
 * @param id Id de la recomendación.
 */
export async function getRecommendationById({commit, state}, id) {

    commit('dashboard/load', true, {root: true});
    await $http_ari.get('recomendaciones/' + id)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRecommendation', response.data.data);
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener tipos de recomendaciones.
 */
export async function getRecommendationTypes({commit, state}) {

    await $http_ari
        .get(`tipos-recomendaciones`)
        .then(response => {
            commit('setRecommendationTypes', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Actualizar recomendación.
 */
export async function updateRecommendation({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});
    await $http_ari.put('recomendaciones/' + state.recommendation.id, state.recommendation)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('resetRecommendation');
            commit('setShowToModal', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

            await dispatch('getRecommendations');
        }).catch(async (error) => {
            commit('dashboard/load', false, {root: true});

            let message = 'Error en la actualización. Por favor intente nuevamente';

            if (error.errors && error.errors.codigo) {
                message = 'El código ya se encuentra en uso';
            }

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Crear recomendación.
 */
export async function addRecommendation({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});
    await $http_ari.post('recomendaciones', state.recommendation)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('resetRecommendation');
            commit('setShowToModal', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

            await dispatch('getRecommendations');
        }).catch(async (error) => {
            commit('dashboard/load', false, {root: true});

            let message = 'Error en la actualización. Por favor intente nuevamente';

            if (error.errors && error.errors.codigo) {
                message = 'El código ya se encuentra en uso';
            }

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

